import { useState, useEffect } from 'react'

export const useGetFDPreviewSlug = (postalCode) => {
  const [callsign, setCallsign] = useState(null)
  const [networkName, setNetworkName] = useState(null)
  const [loadingText, setLoadingText] = useState(null)

  useEffect(() => {
    const fetchPostalCodeData = async () => {
      try {
        const response = await fetch(
          'https://qa.fubo.tv/stream/data/bally_sports_postal_codes.json'
        )
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        const data = await response.json()
        const market = data[postalCode]
        if (market) {
          setCallsign(market.callsign)
          setNetworkName(market.rsnName)
          setLoadingText(null)
        } else {
          setLoadingText('Preview not available in your region.')
        }
      } catch (error) {
        console.error('There was a problem fetching the postal code data:', error)
        setLoadingText('Error loading data')
      }
    }

    if (postalCode) {
      fetchPostalCodeData()
    }
  }, [postalCode])

  return {
    callsign,
    networkName,
    loadingText,
  }
}
